import React from "react";
import {
    SafetyHeroBanner,
    SecurityOverviewWidget,
    SafetyFirstSummary,
    SafetyGuideWidget,
    SafetyKnowMoreCardWidget,
    SafetyFraudCard,
    SafetyFAQWidget,
} from "pageComponents/trust-and-safety";

import SEO from "components/seo";
import Layout from "components/Layout/Layout";

const SecurityHomePage = () => {
    const schemaMarkup = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
            {
                "@type": "Question",
                "name": "Is it safe to transfer money through PhonePe?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text":
                        "Yes, it is 100% safe to send money using the PhonePe app. The details of your transaction can only be seen by you and the person you are sending money to.",
                },
            },
            {
                "@type": "Question",
                "name": "Is the PhonePe app safe?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text":
                        "Yes. PhonePe uses a blend of cutting-edge technology and strong fraud & risk processes to make every user's experience on the app safe and secure",
                },
            },
            {
                "@type": "Question",
                "name": "How do I register a fraud complaint on PhonePe?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text":
                        "You can register your complaint with PhonePe Customer Support by clicking on the Help icon on the Homepage of the app. You can also login to https://support.phonepe.com/ and report your issue.",
                },
            },
            {
                "@type": "Question",
                "name": "How secure is my information on PhonePe?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text":
                        "As soon as you register on PhonePe, your number is validated via an OTP. There is an mPIN or Password setup for all UPI transactions. Also your login from any device is validated through an OTP verification.",
                },
            },
            {
                "@type": "Question",
                "name": "Is it safe to add a bank account on PhonePe?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text":
                        "Adding a bank account on PhonePe is 100% safe & secure.",
                },
            },
            {
                "@type": "Question",
                "name": "How does PhonePe keep my payments safe?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text":
                        "We assign a risk score to every transaction on the app. Transactions with high risk scores are automatically blocked, keeping your payment safe.",
                },
            },
            {
                "@type": "Question",
                "name": "What can I do to keep my transactions safe?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text":
                        "Never share your UPI PIN, OTP, CVV and credit/debit card details with anyone. Never enter your UPI PIN to receive money on PhonePe. Never download third party apps, such as AnyDesk and TeamViewer at the request of unknown callers",
                },
            },
            {
                "@type": "Question",
                "name": "What if someone tries to login to my account?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text":
                        "Any login from a new device will require an OTP, which is sent to your registered mobile number. If an incorrect OTP is used three times, your PhonePe account will be blocked for 24 hours, for your own safety.",
                },
            },
            {
                "@type": "Question",
                "name": "Where can I learn about payment fraud?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text":
                        "Read our blogs to find out about the common types of fraud and how you can stay safe. https://blog.phonepe.com/tagged/phishing",
                },
            },
            {
                "@type": "Question",
                "name": "What's the safest way to reach PhonePe support?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text":
                        "The safest way to get the help you're looking for is to write to us at: Support.phonepe.com. https://www.phonepe.com/contact-us/",
                },
            },
        ],
    };
    return (
        <Layout>
            <SEO
                title="PhonePe Security - Every Payment is Protected on PhonePe"
                description="Your money is safe on PhonePe. With an advanced security infrastructure, all your transactions on PhonePe are safe and protected. Read on to know more!"
                url="https://www.phonepe.com/trust-and-safety/"
                schemaMarkup={schemaMarkup}
            />
            <SafetyHeroBanner />
            <SecurityOverviewWidget />
            <SafetyFirstSummary />
            <SafetyGuideWidget />
            <SafetyKnowMoreCardWidget />
            <SafetyFraudCard />
            <SafetyFAQWidget />
        </Layout>
    );
};

export default SecurityHomePage;
